/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';

import WebViewer from '@pdftron/webviewer';

import { setInstance, setSelectedText } from './DraftSlice';
import { useAppDispatch } from '../../redux/store';

const DocxViewerComponent = (props: any) => {
  const documentContainer = useRef<HTMLDivElement>(null);
  const { fileLink, draftDetails } = props;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fileLink && documentContainer.current && draftDetails) {
      const splitName = draftDetails?.name?.split('.');
      const extension = splitName?.[splitName.length - 1] || 'docx';
      dispatch(setInstance(null));
      if (documentContainer.current) {
        documentContainer.current.innerHTML = '';
      }

      WebViewer.WebComponent(
        {
          path: '/webviewer',
          fullAPI: true,
          ui: 'legacy',
          initialDoc: fileLink,
          css: '/styles/webviewer.css',
          extension: extension,
          disabledElements: [
            'header',
            'toolsHeader',
            'linkButton',
            'annotationCommentButton',
            'contextMenuPopup',
          ],
          licenseKey:
            'Riverus Technology Solutions Pvt  Ltd :OEM:Riverus::B+:AMS(20250530):7255CE8C0477C80A8360B03AB9C2727160610FEBB9361A37E36C05DA5CF50ED654BA31F5C7',
        },
        documentContainer.current
      ).then((instance) => {
        const { Core } = instance;
        const { documentViewer } = Core;
        documentViewer.loadDocument(fileLink);
        instance.UI.annotationPopup.update([{ type: 'ac' }]);

        documentViewer.addEventListener('documentLoaded', async () => {
          dispatch(setInstance(instance));
          const FitMode = instance.UI.FitMode;
          instance.UI.setFitMode(FitMode.FitWidth);
        });

        documentViewer.addEventListener('textSelected', (_, selectedText) => {
          if (selectedText.length > 0) {
            dispatch(setSelectedText(selectedText));
          } else {
            dispatch(setSelectedText(''));
          }
        });
      });
    }
  }, [fileLink, documentContainer, draftDetails]);

  return (
    <div
      ref={documentContainer}
      id="document-viewer"
      style={{ height: '82vh' }}
    />
  );
};

export default DocxViewerComponent;
